import { TFunction } from 'i18next';

import { FormattedOption } from 'types/dictionaries';

import getOptionLabel from 'utils/getOptionLabel';

import { ClientApplicationStages } from 'constants/enums';

export const getInviteForInterviewButtonTooltip = (
  isInviteForInterviewAllowed: boolean,
  t: TFunction,
  clientApplicationStages: FormattedOption[]
): string | false => {
  if (isInviteForInterviewAllowed) {
    return false;
  }

  return t('sidebar.application.interview.request.stageRequiredTooltip', {
    new: getOptionLabel(
      ClientApplicationStages.NewApplicationStageClient,
      clientApplicationStages
    ),
    review: getOptionLabel(
      ClientApplicationStages.ClientReviewApplicationStageClient,
      clientApplicationStages
    )
  });
};
